const questionAnswerMode = {
  SeleccionSimple: 1,
  SeleccionMultiple: 2,
  SeleccionSimpleConInformacionDeEvidencia: 3,
  SeleccionSingularVertical: 4,
  SeleccionSingularHorizontal: 5,
};

export default questionAnswerMode;
